/** page */
export const SET_CRUMB = 'SET_CRUMB'
export const SET_ERROR_BOX = 'SET_ERROR_BOX'
export const SET_LOADING = 'SET_LOADING'
export const SET_PAGE_INFO = 'SET_PAGE_INFO'
export const SET_TOAST = 'SET_TOAST'
export const SET_USER = 'SET_USER'
export const SET_PAGE_USER_TYPE_BY_COOKIE = 'SET_PAGE_USER_TYPE_BY_COOKIE'
export const SWITCH_ERROR_BOX = 'SWITCH_ERROR_BOX'
export const SWITCH_TOAST = 'SWITCH_TOAST'

export const SET_ALERTS = 'SET_ALERTS'
export const CREATE_ALERT = 'CREATE_ALERT'
export const DISMISS_ALERT = 'DISMISS_ALERT'
export const DISMISS_LAST_ALERT = 'DISMISS_LAST_ALERT'
export const RE_LOGIN = 'RE_LOGIN'
export const INVOKE_REDIRECT = 'INVOKE_REDIRECT'
export const SET_NAVIGATION_PAGES = 'SET_NAVIGATION_PAGES'
export const SET_I13NDATA = 'SET_I13NDATA'
export const CREATE_LOG = 'CREATE_LOG'
export const SET_ERROR_BOUNDARY_ERROR = 'SET_ERROR_BOUNDARY_ERROR'
export const FETCH_BASE64_YIMG = 'FETCH_BASE64_YIMG'

/** supplier */
export const PUT_SHARED_LINK = 'PUT_SHARED_LINK'
export const UPDATE_SALE_STAT_SETTINGS = 'UPDATE_SALE_STAT_SETTINGS'
export const REDIRECT_SHARED_LINK = 'REDIRECT_SHARED_LINK'

// reservice action types
// SPA apis
export const FETCH_WSSID = 'FETCH_WSSID'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_PRIVILEGE_PAGES = 'FETCH_PRIVILEGE_PAGES'
export const CHECK_PRIVILEGE = 'CHECK_PRIVILEGE'
export const FETCH_FEATURE_CONFIG = 'FETCH_FEATURE_CONFIG'
export const FETCH_SINGLE_FEATURE_CONFIG = 'FETCH_SINGLE_FEATURE_CONFIG'

export const FETCH_ANNOUNCEMENTS = 'FETCH_ANNOUNCEMENTS'
export const UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT'
export const FETCH_ACTIVITIES = 'FETCH_ACTIVITIES'
export const FETCH_UNHANDLED_ACTIVITIES_COUNT = 'FETCH_UNHANDLED_ACTIVITIES_COUNT'
export const FETCH_STATS_REPORTS = 'FETCH_STATS_REPORTS'
export const FETCH_RANKINGS_STATS = 'FETCH_RANKINGS_STATS'
export const FETCH_SALE_STATS = 'FETCH_SALE_STATS'
export const FETCH_SE_SALE_STATS = 'FETCH_SE_SALE_STATS'
export const FETCH_ORDER_CATEGORY_DISTRIBUTION = 'FETCH_ORDER_CATEGORY_DISTRIBUTION'
export const FETCH_PAGINATION_BESTSELLERS = 'FETCH_PAGINATION_BESTSELLERS'
export const FETCH_SE_PAGINATION_BESTSELLERS = 'FETCH_SE_PAGINATION_BESTSELLERS'
export const FETCH_PAGE_VIEWS = 'FETCH_PAGE_VIEWS'
export const FETCH_SERVICE_DESKS = 'FETCH_SERVICE_DESKS'
export const FETCH_SHORTCUTS = 'FETCH_SHORTCUTS'
export const FETCH_SHORTCUT_SETTINGS = 'FETCH_SHORTCUT_SETTINGS'
export const UPDATE_SHORTCUT_SETTINGS = 'UPDATE_SHORTCUT_SETTINGS'
export const FETCH_PROMOTIONS = 'FETCH_PROMOTIONS'
export const FETCH_INVENTORIES = 'FETCH_INVENTORIES'
export const FETCH_EXPIRING_ITEMS = 'FETCH_EXPIRING_ITEMS'
export const FETCH_UNSALABLE_ITEMS = 'FETCH_UNSALABLE_ITEMS'
export const FETCH_WAREHOUSE_OVERVIEW = 'FETCH_WAREHOUSE_OVERVIEW'
export const FETCH_BRAND_DISTRIBUTION = 'FETCH_BRAND_DISTRIBUTION'
export const FETCH_BRAND_DISTRIBUTION_BY_BRAND_ID = 'FETCH_BRAND_DISTRIBUTION_BY_BRAND_ID'
// dashboard
export const FETCH_SALES_PERFORMANCES = 'FETCH_SALES_PERFORMANCES'
export const FETCH_SEARCH_KEYWORDS = 'FETCH_SEARCH_KEYWORDS'
export const FETCH_LISTING_PAGE_VIEWS = 'FETCH_LISTING_PAGE_VIEWS'
export const FETCH_SE_LISTING_PAGE_VIEWS = 'FETCH_SE_LISTING_PAGE_VIEWS'
export const FETCH_RETURNS = 'FETCH_RETURNS'
export const FETCH_RETURN_REASONS = 'FETCH_RETURN_REASONS'
export const FETCH_SPECIFIC_RETURN_REASONS_LISTINGS = 'FETCH_SPECIFIC_RETURN_REASONS_LISTINGS'
export const FETCH_SPECIFIC_SEARCH_KEYWORD_LISTINGS = 'FETCH_SPECIFIC_SEARCH_KEYWORD_LISTINGS'
export const FETCH_ABANDONED_CARTS = 'FETCH_ABANDONED_CARTS'
export const FETCH_ARRIVAL_NOTICE_SUMMARIES = 'FETCH_ARRIVAL_NOTICE_SUMMARIES'
export const FETCH_LISTING_TAGS = 'FETCH_LISTING_TAGS'
export const FETCH_MEMBER_ANALYSES = 'FETCH_MEMBER_ANALYSES'
export const FETCH_SALE_STATS_BY_DATE = 'FETCH_SALE_STATS_BY_DATE'
export const FETCH_SE_SALE_STATS_BY_DATE = 'FETCH_SE_SALE_STATS_BY_DATE'
export const FETCH_TRACK_LISTINGS = 'FETCH_TRACK_LISTINGS'
export const CREATE_TRACK_LISTINGS = 'CREATE_TRACK_LISTINGS'
export const UPDATE_TRACK_LISTINGS = 'UPDATE_TRACK_LISTINGS'
export const FETCH_PRODUCTS_BUNDLES = 'FETCH_PRODUCTS_BUNDLES'
export const CREATE_SUPPLIER_COUPONS = 'CREATE_SUPPLIER_COUPONS'

// proposal
export const FETCH_PROPOSAL_SUB_STATIONS = 'FETCH_PROPOSAL_SUB_STATIONS'
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
export const FETCH_CATEGORIES_BY_SUB_STATIONS = 'FETCH_CATEGORIES_BY_SUB_STATIONS'
export const FETCH_CATEGORY_OPTIONS = 'FETCH_CATEGORY_OPTIONS'
export const FETCH_RECENTLY_CATEGORY_OPTIONS = 'FETCH_RECENTLY_CATEGORY_OPTIONS'
export const FETCH_STRU_DATA_ATTR_CLUSTER_OPTIONS = 'FETCH_STRU_DATA_ATTR_CLUSTER_OPTIONS'
export const FETCH_PROPOSALS = 'FETCH_PROPOSALS'
export const FETCH_MULTIPLE_PROPOSALS = 'FETCH_MULTIPLE_PROPOSALS'
export const FETCH_NO_CACHE_PROPOSALS = 'FETCH_NO_CACHE_PROPOSALS'
export const CREATE_PROPOSALS = 'CREATE_PROPOSALS'
export const UPDATE_PROPOSALS = 'UPDATE_PROPOSALS'
export const FETCH_LISTINGS = 'FETCH_LISTINGS'
export const FETCH_SPECIFIC_LISTING = 'FETCH_SPECIFIC_LISTING'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_SUB_STATION_ID_BY_CATITEM_ID = 'FETCH_SUB_STATION_ID_BY_CATITEM_ID'
export const FETCH_LISTING_MODEL_PROPOSALS = 'FETCH_LISTING_MODEL_PROPOSALS'
export const CREATE_LISTING_MODEL_PROPOSALS = 'CREATE_LISTING_MODEL_PROPOSALS'
export const UPDATE_LISTING_MODEL_PROPOSALS = 'UPDATE_LISTING_MODEL_PROPOSALS'
export const FETCH_LISTING_INFO_PROPOSAL = 'FETCH_LISTING_INFO_PROPOSAL'
export const CREATE_LISTING_INFO_PROPOSAL = 'CREATE_LISTING_INFO_PROPOSAL'
export const UPDATE_LISTING_INFO_PROPOSAL = 'UPDATE_LISTING_INFO_PROPOSAL'
export const FETCH_BATCH_PROPOSAL = 'FETCH_BATCH_PROPOSAL'
export const CREATE_BATCH_PROPOSAL = 'CREATE_BATCH_PROPOSAL'
export const UPDATE_BATCH_PROPOSAL = 'UPDATE_BATCH_PROPOSAL'
export const POST_BATCH_PROPOSAL = 'POST_BATCH_PROPOSAL'
export const FETCH_BRANDS = 'FETCH_BRANDS'
// badwords
export const FETCH_BAD_WORDS = 'FETCH_BAD_WORDS'
// S3 API action types
export const FETCH_TEMP_CREDENTIAL = 'FETCH_TEMP_CREDENTIAL'
export const FETCH_S3_OBJECT = 'FETCH_S3_OBJECT'
export const FETCH_S3_WSSID = 'FETCH_S3_WSSID'
// SCM API
export const CREATE_LOGIN_TOKEN = 'CREATE_LOGIN_TOKEN'
export const FETCH_BEST_SELLER_SOLD_OUT_COUNT = 'FETCH_BEST_SELLER_SOLD_OUT_COUNT'
export const FETCH_BEST_SELLER_SOLD_OUT = 'FETCH_BEST_SELLER_SOLD_OUT'
export const FETCH_NEED_REVIEW_COUNT = 'FETCH_NEED_REVIEW_COUNT'
export const FETCH_NEED_REVIEWS = 'FETCH_NEED_REVIEWS'
export const UPDATE_COMMENTS = 'UPDATE_COMMENTS'
export const UPDATE_SALABLE_AMOUNT = 'UPDATE_SALABLE_AMOUNT'
export const FETCH_GD_ON_AND_OFF_BY_ID = 'FETCH_GD_ON_AND_OFF_BY_ID'
export const UPDATE_GD_ON = 'UPDATE_GD_ON'
export const UPDATE_GD_OFF = 'UPDATE_GD_OFF'
export const FETCH_PROBLEMS_COUNT = 'FETCH_PROBLEMS_COUNT'
export const FETCH_PROBLEMS = 'FETCH_PROBLEMS'
export const FETCH_PROBLEM_DETAIL = 'FETCH_PROBLEM_DETAIL'
export const UPDATE_ANSWERS = 'UPDATE_ANSWERS'
// SCM Notify API
export const FETCH_VAPID = 'FETCH_VAPID'
export const FETCH_CHECK_SUBSCRIBE = 'FETCH_CHECK_SUBSCRIBE'
export const FETCH_NOTIFICATION_COUNT = 'FETCH_NOTIFICATION_COUNT'
export const FETCH_NOTIFICATION_BY_ID = 'FETCH_NOTIFICATION_BY_ID'
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'
export const CREATE_SUBSCRIBE = 'CREATE_SUBSCRIBE'
export const UPDATE_READ_NOTIFICATION = 'UPDATE_READ_NOTIFICATION'
export const UPDATE_READ_ALL_NOTIFICATIONS = 'UPDATE_READ_ALL_NOTIFICATIONS'
export const DELETE_SUBSCRIBE = 'DELETE_SUBSCRIBE'
// OT API
export const FETCH_SE_COOKIE = 'FETCH_SE_COOKIE'
export const FETCH_SE_WSSID = 'FETCH_SE_WSSID'
export const FETCH_SE_USER = 'FETCH_SE_USER'
